export const NavbarLinks = [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "Courses",
    path: "/courses",
  },
  {
    title: "About Us",
    path: "/about",
  },
  {
    title: "Contact Us",
    path: "/contact",
  },
  {
    title: "Knowledge Center",
    path: "/blogs",
  },
  {
    title: "Plans",
    path: "/plans",
  },
];
